<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-06-24 10:04:55
 * @LastEditors: lau
 * @LastEditTime: 2023-02-13 16:49:06
-->
<!-- 停车场剩余车位上报接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "cmd": "",
          "id": "",
          "carCode": "",
          "name": "",
          "addTime": "",
          "operateTime": "",
          "remark1": "",
          "remark2": "",
          "remark3": "",
          "timePeriodList": [{},{}],
          "reason": "",
          "isDeleted": "",
          "specialCarTypeConfigId": "",
          "sysVersion": "",
          "visitTimeFrom": "",
          "visitTimeTo": "",
          "operateType": "",
          "parkList": [{},{}]

 
        },
        responseCode: {
          "data": {},
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动上报黑名单变更信息到第三方接入系统",
          urlPattern: this.commonUrls.third + "reportBlacklist",
          precondition: "无",
          fitSystem: "云停车场，VEMS传统车场(前提通过接口添加的黑名单)",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency: "实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'id',
                info2: '是',
                info3: 'Long',
                info4: '黑名单ID'
              }, {
                info1: 'carCode',
                info2: '否',
                info3: 'String',
                info4: '车牌号码'
              }, {
                info1: 'owner',
                info2: '否',
                info3: 'String',
                info4: '黑名单名称'
              }, {
                info1: 'addTime',
                info2: '否',
                info3: 'String',
                info4: '添加时间'
              }, {
                info1: 'operateTime',
                info2: '否',
                info3: 'String',
                info4: '操作时间'
              }, {
                info1: 'remark1',
                info2: '否',
                info3: 'String',
                info4: '备注1'
              }, {
                info1: 'remark2',
                info2: '否',
                info3: 'String',
                info4: '备注2'
              }, {
                info1: 'remark3',
                info2: '否',
                info3: 'String',
                info4: '备注3'
              }, {
                info1: 'timePeriodList',
                info2: '否',
                info3: 'String',
                info4: '时间段列表yyyy-mm-dd hh:mm:ss~yyyy-mm-dd hh:mm:ss'
              }, {
                info1: 'reason',
                info2: '否',
                info3: 'String',
                info4: '来访原因'
              }, {
                info1: 'isDeleted',
                info2: '否',
                info3: 'Integer',
                info4: '是否删除：0否，1是'
              }, {
                info1: 'specialCarTypeConfigId',
                info2: '否',
                info3: 'Long',
                info4: '特殊车辆类型ID'
              }, {
                info1: 'sysVersion',
                info2: '否',
                info3: 'BigDecimal',
                info4: '系统版本'
              }, {
                info1: 'isPermanent',
                info2: '是',
                info3: 'Integer',
                info4: '是否永久(0否，1是)'
              },{
                info1: 'visitTimeFrom',
                info2: '否',
                info3: 'BigDecimal',
                info4: '黑名单禁止访问开始时间yyyyMMddHHmmss'
              }, {
                info1: 'visitTimeTo',
                info2: '否',
                info3: 'BigDecimal',
                info4: '黑名单禁止访问结束时间yyyyMMddHHmmss'
              }, {
                info1: 'operateType',
                info2: '否',
                info3: 'Integer',
                info4: '操作类型：0 新增，1 修改，2 删除'
              }, {
                info1: 'parkList',
                info2: '否',
                info3: 'JSONArray',
                info4: '适用车场'
              }
            ]
          }, {
            titleName: 'parkList',
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'parkCode',
                info2: '是',
                info3: 'String',
                info4: '车场名称'
              },
              {
                info1: 'parkName',
                info2: '是',
                info3: 'String',
                info4: '车场名称'
              }
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: []
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{
              tableHead: '状态码',
              tdName: 'info1'
            }, {
              tableHead: '说明',
              tdName: 'info2'
            }],
            td: []
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportBlacklist.vue